var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6322 15H2.2887C1.73641 15 1.2887 14.5523 1.2887 14V12.5V11C1.2887 10.4477 1.73641 10 2.2887 10H19.6322C20.0121 10 20.1781 9.52018 19.8794 9.28548L14.6097 5.14476C14.1623 4.7932 14.098 4.13969 14.4683 3.70767L16.1282 1.77116C16.4916 1.34721 17.1317 1.30297 17.55 1.6729L28.9443 11.751C29.3942 12.1489 29.3942 12.851 28.9443 13.249L17.55 23.3271C17.1317 23.697 16.4916 23.6528 16.1282 23.2288L14.4683 21.2923C14.098 20.8603 14.1623 20.2068 14.6097 19.8552L19.8794 15.7145C20.1781 15.4798 20.0121 15 19.6322 15Z",
    fill: "#013B6A",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.bfceabc7baf5cd07be596dbc801dcfd5.svg";
export { ForwardRef as ReactComponent };